'use strict'

import React from 'react';

export default class FilterStatus extends React.Component {
  render() {
    var activeFiltered=this.props.excludedProjects.filter(project=>project.isStarted).length;
    var inactiveFiltered=this.props.excludedProjects.filter(project=>!project.isStarted).length;
    return this.props.filter!==undefined && this.props.excludedProjects!==undefined && this.props.excludedProjects.length>0 ? (
          <div style={{color:"#212121", padding:10, marginTop: 10, marginLeft:30, marginRight: 30, fontFamily:"Lato", textAlign:"center", backgroundColor:"#FFEADB"}}>
            {activeFiltered>0 ? activeFiltered+" active" : ""}{inactiveFiltered>0 && activeFiltered>0 ? " and " : ""}{inactiveFiltered>0 ? inactiveFiltered +" inactive" : ""} project(s) are hidden with current filter
          </div>
        ) : null;
  }
}



// WEBPACK FOOTER //
// ./views/components/FilterStatus.jsx